import './App.css'
import { BrowserRouter, Switch } from 'react-router-dom'
import {
  Home,
  Login,
  Courses,
  Recordings,
  RecordingPlayer,
  PrivacyPolicy,
} from './views'
import { NavBar, Route } from './components'

import axios from 'axios'

import 'bootstrap'
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css'
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css'

axios.defaults.baseURL = process.env.REACT_APP_BACKEND_API

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <NavBar />
        <Switch>
          <Route exact open path="/" Component={Home} />
          <Route exact path="/login" Component={Login} />
          <Route exact auth path="/courses" Component={Courses} />
          <Route
            exact
            auth
            path="/recordings"
            Component={Recordings}
          />
          <Route
            exact
            auth
            path="/recordings/:instanceId"
            Component={Recordings}
          />
          <Route
            exact
            open
            path="/recording/:recordingId"
            Component={RecordingPlayer}
          />
          <Route exact open path="/privacy-policy" Component={PrivacyPolicy} />
        </Switch>
      </div>
    </BrowserRouter>
  )
}

export default App
